$(document).on("click",'.collection-pagination button.loadMore',function(e){
    e.preventDefault();
    let moreURL = $(this).attr('data-url');
    let sectionID = $(this).attr('data-section-id');
    loadMore(moreURL,sectionID);
});
loadMore = function(moreURL,sectionID) {
    if (moreURL.length){
      $.ajax({
        type: 'GET',
        url: moreURL,
        beforeSend:function(){
          $('.collection-pagination button.loadMore').attr('disabled','disabled');
        },
        complete: function (data) {
          if($('#product-grid').length && data.responseText){
            var jsonData = JSON.parse(data.responseText)
            var responseText = $(jsonData[sectionID]);
            $("#product-grid").append($("#product-grid", responseText).html());
            $("#ProductCountDesktop").html($("#ProductCountDesktop", responseText).html());
            $("#ProductCount").html($("#ProductCount", responseText).html());
            $(".loading-viewed").html($(".loading-viewed", responseText).html());
            if($("#collectionLoadMore", responseText).length){
                $("#collectionLoadMore").attr('data-url',$("#collectionLoadMore", responseText).attr('data-url'))
            }else{
                $("#collectionLoadMore").hide();
            }
            $('.collection-pagination button.loadMore').removeAttr('disabled');
            yotpo.refreshWidgets();
          }
        }
      });
    }
}